import {
    AtualizarContatoTelefoneService,
    CadastrarContatoTelefoneService,
    DeletarContatoTelefoneService,
    ListarContatosTelefoneService,
    ListarContatosTelefoneUAUService,
} from "../../../../Services/Geral/Contatos/ContatoTelefone/ContatoTelefoneService";
import {
    IContatoTelefone,
    IDeletarContatoTelefone,
} from "../../../../Interfaces/Geral/Contatos/ContatoTelefone/ContatoTelefoneInterface";

import { Controller } from "../../../Controller";

export async function ListarContatosTelefoneController(idContato: number) {
    return Controller(ListarContatosTelefoneService(idContato));
}

export async function ListarContatosTelefoneUAUController(
    DS_CHAVE_ERP: string
) {
    return Controller(ListarContatosTelefoneUAUService(DS_CHAVE_ERP));
}

export async function AtualizarContatoTelefoneController(
    requestBody: IContatoTelefone
) {
    return Controller(AtualizarContatoTelefoneService(requestBody));
}

export async function DeletarContatoTelefoneController(
    requestBody: IDeletarContatoTelefone
) {
    return Controller(
        DeletarContatoTelefoneService(requestBody),
        "Telefone removido de contato com sucesso!"
    );
}

export async function CadastrarContatoTelefoneController(
    requestBody: IContatoTelefone
) {
    return Controller(CadastrarContatoTelefoneService(requestBody));
}
